import { render, staticRenderFns } from "./ListadoDeclaracion.vue?vue&type=template&id=644efe30&scoped=true"
import script from "./ListadoDeclaracion.vue?vue&type=script&lang=js"
export * from "./ListadoDeclaracion.vue?vue&type=script&lang=js"
import style0 from "./ListadoDeclaracion.vue?vue&type=style&index=0&id=644efe30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644efe30",
  null
  
)

export default component.exports